import { createFileRoute, redirect } from "@tanstack/react-router";

// Merged into the fuller /custom-home-builder-remodeler-marketing-colorado page (301 to avoid duplicate pages competing in search).
export const Route = createFileRoute("/custom-home-builder-marketing-colorado")({
  beforeLoad: () => {
    throw redirect({ to: "/custom-home-builder-remodeler-marketing-colorado", statusCode: 301 });
  },
});
